import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {} });

const STORAGE_KEY = "asm_theme";

export const ThemeProvider = ({ children }) => {
	const [theme, setTheme] = useState(() => {
		try {
			return localStorage.getItem(STORAGE_KEY) || "light";
		} catch {
			return "light";
		}
	});

	useEffect(() => {
		document.body.classList.toggle("theme-dark", theme === "dark");
		document.body.classList.add("asm-design");
		try {
			localStorage.setItem(STORAGE_KEY, theme);
		} catch {}
	}, [theme]);

	const toggle = () =>
		setTheme((t) => (t === "dark" ? "light" : "dark"));

	return (
		<ThemeContext.Provider value={{ theme, toggle, setTheme }}>
			{children}
		</ThemeContext.Provider>
	);
};

export const useTheme = () => useContext(ThemeContext);
